import { Message } from 'element-ui'

const recent = new Map()

export function toastError(message, { key, dedupeMs } = {}) {
  const text = String(message || '').trim()
  if (!text) return

  const dedupeWindow = typeof dedupeMs === 'number' ? dedupeMs : 2000
  const dedupeKey = key || `error:${text}`
  const now = Date.now()
  const lastAt = recent.get(dedupeKey) || 0
  if (dedupeWindow > 0 && now - lastAt < dedupeWindow) return
  recent.set(dedupeKey, now)

  Message.error(text)
}

